__turbopack_context__.v({
  "fullWidthNav": "Navigation-module__IlDxDG__fullWidthNav",
  "navigation": "Navigation-module__IlDxDG__navigation",
  "rightNavigation": "Navigation-module__IlDxDG__rightNavigation",
});
